import { NotFoundRouteProps, useNavigate } from '@tanstack/react-router';
import { Error, ErrorFooter, ErrorMessage, ErrorTitle } from './Error';
import { Button, Flex } from '@radix-ui/themes';
import { ErrorPage } from '~/icons/ErrorPage';
import { Header } from '../Header/Header';
import { AccountDropdown } from '~/components/AccountDropdown/AccountDropdown';
import { useState } from 'react';
import { useSession } from '~/features/auth/context/Session';

export function RouteNotFoundErrorBoundary(props: NotFoundRouteProps) {
  const navigate = useNavigate();
  const { session } = useSession();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Flex direction="column" width="100%" height="100%" minHeight="100vh">
      <Header>
        {session && <AccountDropdown isPopoverOpen={isPopoverOpen} setIsPopoverOpen={setIsPopoverOpen} />}
      </Header>
      <Flex align="center" justify="center" width="100%" flexGrow="1">
        <Error>
          <ErrorTitle>Page Not Found</ErrorTitle>
          <ErrorMessage>It seems the page you‘re looking for isn‘t here.</ErrorMessage>
          <ErrorFooter>
            <Button
              variant="outline"
              color="gray"
              onClick={() =>
                void navigate({
                  to: '/',
                })
              }
            >
              Go back
            </Button>
          </ErrorFooter>
          <Flex align="center" justify="center" width="100%">
            <ErrorPage />
          </Flex>
        </Error>
      </Flex>
    </Flex>
  );
}
